<template>

  <el-main id="register-alternate">


    <div
        id="acceptance-form"
        v-loading="loading"
    >

      <div v-if="errorMessage" id="nomination-error">
        <h3>Sorry, we have encountered an error.</h3>
        <p>{{ errorMessage }}</p>
        <p>Please call head office on <a href="tel:0263560300" class="tel">02 6356 0300</a> for further details.</p>
      </div>


      <template v-else>

        <p><strong>{{ nominee.fullName }}</strong>, please confirm or decline your registration as an alternate for the
          delegate below.</p>

        <el-card
            id="delegate-details"
            class="person-details"
            shadow="never"
        >
          <h4>Delegate details</h4>
          <h3>{{ delegate.fullName }}</h3>
          <p>{{ branch }}</p>
        </el-card>

        <p class="submit">
          <el-button
              type="info"
              plain
              :disabled="!delegate.fullName"
              @click="sendResponse(false)"
          >
            Decline
          </el-button>

          <el-button
              type="primary"
              :disabled="!delegate.fullName"
              @click="sendResponse(true)"
          >
            Accept
          </el-button>
        </p>
      </template>
    </div>
  </el-main>
</template>

<script>

import {$axios} from '../../_helper/axiosWrapper.js'

import {mapState} from "vuex"


import {Person} from './person.js'

export default {
  name: "AcceptanceForm",
  props: {
    credentials: {}
  },
  data() {
    return {
      nominee: new Person(),
      delegate: new Person(),
      branch: '',
      token: null,
      loading: false,
      errorMessage: '',
      forwardingUrls: {
        accept: '',
        decline: '',
        error: ''
      }
    }
  },
  computed: {
    ...mapState(['baseURL'])
  },
  watch: {
    credentials() {
      this.init()
    }
  },
  methods: {
    async init() {

      try {

        this.loading = true


        const queryParams = Object.entries(this.credentials).map(([key, value]) => `${key}=${value}`).join('&')

        // query nominations endpoint
        const initiateResponse = await $axios.post(
            {
              url: `/nominations/invitation?${queryParams}`,
              baseURL: this.baseURL
            },
            'Sorry, we had a problem initiating the acceptance process.'
        )


        // handle errors
        if (initiateResponse?.status !== 200) {

          const {message} = initiateResponse.data
          this.errorMessage = message || 'Sorry, we had a problem initiating the acceptance process.'
          return
        }

        // load results
        const {
          token,
          nomineeInfo,
          memberInfo,
          nominationBranch,
          acceptURL,
          declineURL,
          errorURL
        } = initiateResponse.data

        this.token = token
        this.nominee = nomineeInfo
        this.delegate = memberInfo
        this.branch = nominationBranch
        this.forwardingUrls = {
          accept: acceptURL.replace('~',''),
          decline: declineURL.replace('~',''),
          error: errorURL.replace('~','')
        }

      } finally {
        this.loading = false
      }

    },
    async sendResponse(decision) {

      try {

        this.loading = true

        const payload = {
          NomineeId: this.nominee.id,
          MemberId: this.delegate.id,
          Acceptance: decision.toString(),
          EventCode: this.credentials.eventCode,
          Branch: this.branch,
          token: this.token
        }

        const confirmationResponse = await $axios.post({
          url: '/nominations/result',
          baseURL: this.baseURL,
          // headers: {Authorization: `Bearer ${this.token}`},
          data: payload
        }, 'Sorry, we had a problem confirming your response with the server.')


        // handle and forward if error
        // todo confirm behaviour here, should we redirect to error page or just show error message?
        if (confirmationResponse?.status !== 200) {

          const {message} = confirmationResponse.data
          this.errorMessage = message || 'Sorry, we had a problem confirming your response with the server.'

          window.location = this.forwardingUrls.error
          return
        }

        // redirect to appropriate URL
        window.location = decision ? this.forwardingUrls.accept : this.forwardingUrls.decline

      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">

</style>